import { FC, ReactElement } from "react";

import classes from "./LightTooltipContent.module.css";

interface StyledTooltipContentProps {
  name?: string;
  info: (ReactElement | string)[];
}

const LightTooltipContent: FC<StyledTooltipContentProps> = ({ name, info }) => {
  return (
    <div>
      <ul className={`${classes["tooltip-info-list"]} ${classes.text}`}>
        {name && <li className={classes.title}>{name}</li>}
        {info.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default LightTooltipContent;
